import React, { useContext } from 'react'
import Accordion from '@components/Accordion/Accordion.component'
import { AccordionContainer, AccordionContent, Line } from '@views/Checkout/Checkout.style'
import LotInfo from '../LotInfo/LotInfo.component'
import DurationSectionComponent from '../DurationSection/DurationSection.component'
import { LotViewName } from '../../../../types/lot.interface'
import { CheckoutContext } from '@context/CheckoutContext/checkout.context'
import { useTranslation } from 'react-i18next'

const OrderDetails = () => {
    const { checkout } = useContext(CheckoutContext)
    const { t } = useTranslation()
    return (
        <AccordionContainer>
            <Accordion
                title={
                    checkout?.lotCheckoutType === LotViewName.SUBSCRIPTION
                        ? t('checkout.subscriptions.details')
                        : t('checkout.bookingDetails')
                }
                content={
                    <AccordionContent>
                        <LotInfo lot={checkout?.lot || null} />
                        <Line />
                        <DurationSectionComponent checkout={checkout} />
                    </AccordionContent>
                }
            />
        </AccordionContainer>
    )
}

export default React.memo(OrderDetails)
